import { categories } from '@/mocks/categories';
import CategoryCard from '@/components/base/CategoryCard';

export default function CategoryOverview() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 mb-3">
            研究领域
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大研究方向，从制度分析到文化解读，全方位探索三级片在亚洲电影史中的学术价值
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <CategoryCard
              key={cat.slug}
              slug={cat.slug}
              name={cat.name}
              icon={cat.icon}
              description={cat.description}
              color={cat.color}
              count={cat.count}
            />
          ))}
        </div>
      </div>
    </section>
  );
}